export default "__VITE_ASSET__BbEOcMLA__"